// @flow
import React, { createContext, useContext } from 'react';
import type { Node } from 'react';
import type { Layer } from '../types';

type Context = $ReadOnly<{
    layer: ?Layer
}>;

const LayerContext = createContext<Context>({});

type Props = $ReadOnly<{
    layer: ?Layer,
    children: Node
}>;

export const LayerProvider = ({ layer, children }: Props) => {
    const context = {
        layer
    };

    return (
        <LayerContext.Provider value={context}>
            {children}
        </LayerContext.Provider>
    );
};

export const useLayerContext = () => useContext(LayerContext);

export const useLayer = () => {
    const context = useLayerContext();
    return context.layer;
};